import styled from '@emotion/styled';

export const ProudPartnersCreatorsLogosWrapper = styled.div`
  display: flex;
  gap: var(--spacing-16);

  @media (min-width: 600px) {
    border-left: 1px solid var(--color-neutral-40);
    gap: initial;

    > * {
      padding-left: var(--spacing-16);
    }
  }
`;
